import { Grid } from '@mui/material'
import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useTrocaTabelaHorarioContext } from 'pages/TrocaTabelaHorarios'
import { useParams } from 'react-router-dom'
import {
    tabelaHorarios,
    trocaHorario,
    UpdateTabelaHorarioFuncionarioSchema,
} from 'service/api'
import { toast } from 'sonner'

export default function EditarTrocaTabelaHorario() {
    const { id } = useParams<{ id: string }>()
    const { data } = useTrocaTabelaHorarioContext()
    const { mutateAsync, isLoading } =
        tabelaHorarios.funcionario.mutations.useUpdate({
            invalidateQuery: true,
        })

    const tabela = data?.find(it => it.id === Number(id))
    if (!tabela) return null

    function handleSubmit(values: any) {
        return mutateAsync(
            { ...values, id: Number(id) },
            {
                onSuccess: () => {
                    toast.success('Troca atualizada com sucesso!')
                    trocaHorario.invalidateQueries()
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            open={hasPermission(['update', 'TrocaDeTabelaDeHorário'])}
            width="35rem"
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
            defaultValues={tabela}
            schema={UpdateTabelaHorarioFuncionarioSchema}
        >
            <Dialog.Title>Editar {tabela.TabelaHorario.nome}</Dialog.Title>
            <Dialog.Content dividers>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormField
                            label="Data inicial"
                            name="dtInicial"
                            type="date"
                            required
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormField
                            label="Data final"
                            name="dtFinal"
                            type="date"
                            helperText="Deixe em branco para indeterminado"
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
